import React, { forwardRef } from 'react';
import { Tooltip as MuiTooltip, type TooltipProps } from '@mui/material';

export type { TooltipProps };

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(
  ({ children, ...props }, ref) => {
    return (
      <MuiTooltip ref={ref} {...props}>
        {children}
      </MuiTooltip>
    );
  }
);

Tooltip.displayName = 'Tooltip';

export default Tooltip;
